/*
 * @format
 *
 * Functions to manage copying schedules
 */

import { sortSchedule, flattenSchedule, unflattenSchedule } from './schedule';
import { validDays, getDaySchedule } from './utils';

// replaces the schedule
// importSchedule (flattened schedule object), dayToCopy (string of day), daysToCopyTo (array of days to replace)
export const copySchedule = (importSchedule, dayToCopy, daysToCopyTo) => {
  if (!Array.isArray(importSchedule)) {
    throw Error('ImportSchedule was not passed in as array');
  }

  if (!Array.isArray(daysToCopyTo)) {
    throw Error(
      'Days to copy to (array) was not in correct format (word with capital - e.g. ["Monday","Tuesday"])',
    );
  }
  if (!daysToCopyTo.every(day => validDays.includes(day))) {
    throw Error(
      'The day(s) provided for daysToCopyTo are not in a correct format (word with capital - e.g. ["Monday","Tuesday"])',
    );
  }

  if (!validDays.includes(dayToCopy)) {
    throw Error(
      'Day to copy was not in correct format (word with capital - e.g. "Monday")',
    );
  }
  if (Array.isArray(importSchedule)) {
    if (Array.isArray(importSchedule[0].events)) {
      throw Error(
        "The object passed to this method has not been flattened \n (check you've flattened by calling the flattenSchedule function from /schedule.js before calling this function)",
      );
    }
  }

  // sets schedule to target
  const schedule = unflattenSchedule([...importSchedule]);
  // stores schedule to replace others with
  const newSchedule = getDaySchedule(dayToCopy, schedule);
  // filters down days to keep
  const filteredSchedule = schedule.filter(
    dayEvents => !daysToCopyTo.includes(dayEvents.day),
  );
  // maps out days to replace
  const replacementDays = daysToCopyTo.map(day => ({
    day,
    events: newSchedule,
  }));
  // replaces and returns flattened
  return flattenSchedule([...filteredSchedule, ...replacementDays]).sort(
    sortSchedule,
  );
};

export default copySchedule;
